import { ApiProperty } from "@nestjs/swagger";

export class CategorySubCategoryReq{
    @ApiProperty()
    itemCategoryId:number;
    @ApiProperty()
    itemSubCategoryId:number;
    @ApiProperty()
    unitId:number;
    @ApiProperty()
    saleOrderId?:number;
}